<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-07-28 10:57:01
 * @LastEditTime: 2021-11-18 16:09:29
 * @Description:
-->

<template>
    <div class="jdmall-portal-content">
        <!-- <div class="portal-breadcrumb">
            <span class="portal-breadcrumb-start"
                >{{ selectedMenu.name
                }}<span class="portal-breadcrumb-split">/</span></span
            >
            {{ selectedSubMenu.title }}
        </div> -->
        <div id="subapp"></div>
        <!-- <iframe
            border="0"
            width="100%"
            frameborder="0"
            ref="iframe"
            v-show="loadIframe"
            :src="iframeItem.entry"
            class="iframe"
        ></iframe> -->
        <div id="jdmall-portal-pendant">
            <div
                @click="openStudyCenter"
                class="study"
                :style="{ 'pointer-events': isDragging ? 'none' : 'auto' }"
            >
                <img
                    src="https://ocrestudy.jd.com/static/img/logo.984cd676.svg"
                />运营端学习
            </div>
            <div
                @click="openSmallBell"
                class="jdBell"
                :style="{ 'pointer-events': isDragging ? 'none' : 'auto' }"
            >
                <img
                    src="https://jdbell.jd.com/static/img/logo.c0c01da9.png"
                />小京铃提报
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { regMicroApps } from '../micro-application'
export default {
    name: 'portalContent',
    props: {},
    data() {
        return {
            isDragging: false,
        }
    },
    methods: {
        // 设置菜单高亮
        setActiveSubMenu(val) {
            console.log('setActiveSubMenu')
            let microData = val
            if (window.location.pathname === '/' && microData.length) {
                history.pushState(
                    null,
                    `${microData[0].activeLinkUrl}`,
                    `${microData[0].activeLinkUrl}`
                )
            }
            if (window.location.pathname !== '/') {
                microData.forEach((item) => {
                    if (
                        window.location.pathname === item.activeLinkUrl ||
                        window.location.pathname.indexOf(item.activeLinkUrl) !==
                            -1 ||
                        `${window.location.pathname}${window.location.hash}`.indexOf(
                            item.activeLinkUrl
                        ) !== -1
                    ) {
                        console.log(item)
                        this.$store.dispatch('app/setSelectedSubMenu', item)
                        this.$store.dispatch('app/setSelectedMenu', item.parent)
                        this.$store.dispatch(
                            'app/setSubMenu',
                            item.parent.childrenMenuList
                        )
                    }
                })
            }
        },
        openStudyCenter() {
            // 生产环境
            const studyCenterUrl = {
                // 职能权限
                XSTORE_CTWX_FUNCTIONAL:
                    'https://jdstudy.jd.com/api/share/index?courseId=5114&channel=13&identity=31',
                // 商品
                XSTORE_CTWX_MAN_PRODUCT:
                    'https://jdstudy.jd.com/api/share/index?courseId=5113&channel=13&identity=31',
                // 订单管理
                JDMALL_ORDER:
                    'https://jdstudy.jd.com/api/share/index?courseId=5112&channel=13&identity=31',
                // 供应链
                XSTORE_CTWX_SUPPLY_MANAGEMENT:
                    'https://jdstudy.jd.com/api/share/index?courseId=5111&channel=13&identity=31',
                // 库存管理
                XSTORE_DMS_STOCK_MANAGEMENT:
                    'https://jdstudy.jd.com/api/share/index?courseId=5110&channel=13&identity=31',
                // 门店管理
                XSTORE_CTWX_SHOP:
                    'https://jdstudy.jd.com/api/share/index?courseId=5109&channel=13&identity=31',
                // 财务管理
                SS_FINANCE:
                    'https://jdstudy.jd.com/api/share/index?courseId=5108&channel=13&identity=31',
                // 客服
                XSTORE_CTWX_CUSTOMER_SERVIC:
                    'https://jdstudy.jd.com/api/share/index?courseId=5107&channel=13&identity=31',
            }
            const element = studyCenterUrl[this.selectedMenu.code]
            if (element) {
                window.open(element, '_blank')
            } else {
                window.open(studyCenterUrl['XSTORE_CTWX_FUNCTIONAL'], '_blank')
            }
        },
        openSmallBell() {
            window.open(
                '//million-activity.jd.com/report?platformId=46&source=23',
                '_blank'
            )
        },
        // 监听右下角图标移动
        handlePendantMove() {
            const pendant = document.querySelector('#jdmall-portal-pendant')
            const container = document.querySelector(
                '.jdmall-portal.app-container'
            )

            let x, y, left, top, nLeft, nTop

            // 鼠标按下
            const starDrag = (e) => {
                // 1. 记录鼠标按下时的鼠标位置
                x = e.clientX
                y = e.clientY
                // 2. 记录元素初始位置
                left = pendant.offsetLeft
                top = pendant.offsetTop
                // 3. 将事件绑定到容器中，避免鼠标离开元素时，元素就不再跟随鼠标移动
                container.addEventListener('mousemove', drag)
                container.addEventListener('mouseup', stopDrag)
            }

            // 鼠标移动
            const drag = (e) => {
                this.isDragging = true
                const nx = e.clientX
                const ny = e.clientY
                nLeft = nx - (x - left)
                nTop = ny - (y - top)

                // 限制挂件移动范围
                const overflow =
                    nLeft < 0 ||
                    nTop < 0 ||
                    nLeft > container.clientWidth - pendant.clientWidth ||
                    nTop > container.clientHeight - pendant.clientHeight
                let tX = nx - x
                let tY = ny - y
                if (overflow) {
                    nLeft < 0 && (tX = -left)
                    nLeft > container.clientWidth - pendant.clientWidth &&
                        (tX =
                            container.clientWidth - pendant.clientWidth - left)
                    nTop < 0 && (tY = -top)
                    nTop > container.clientHeight - pendant.clientHeight &&
                        (tY =
                            container.clientHeight - pendant.clientHeight - top)
                }
                nLeft = tX + left
                nTop = tY + top

                pendant.style.transform = `translate(${tX}px,${tY}px)`
            }

            // 鼠标松开
            const stopDrag = () => {
                this.isDragging = false

                // 停止拖拽后，设置挂件的left和top，并还原transform
                pendant.style.left = nLeft + 'px'
                pendant.style.top = nTop + 'px'
                pendant.style.transform = 'none'

                container.removeEventListener('mousemove', drag)
                container.removeEventListener('mouseup', stopDrag)
            }

            pendant.addEventListener('mousedown', starDrag)
        },
    },
    mounted() {
        regMicroApps()
        this.handlePendantMove()
    },
    computed: {
        ...mapGetters({
            microData: 'microData',
            menuData: 'menuData',
            selectedMenu: 'selectedMenu',
            selectedSubMenu: 'selectedSubMenu',
        }),
    },
    watch: {
        microData(val) {
            this.setActiveSubMenu(val)
        },
    },
}
</script>

<style lang="scss" scoped>
.jdmall-portal-content {
    flex: 1;
    margin-top: 48px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.portal-breadcrumb {
    padding-left: 24px;
    height: 40px;
    line-height: 40px;
    background: rgba(254, 254, 254, 1);
    font-size: 14px;
    color: #1a1a1a;
    &-start {
        color: rgba(26, 26, 26, 0.45);
    }
    &-split {
        margin-left: 4px;
        margin-right: 2px;
    }
}

#subapp {
    flex: 1;
    overflow-y: auto;
    background-color: #f5f5f5;
}

#jdmall-portal-pendant {
    position: absolute;
    right: 1px;
    bottom: 20px;
    width: max-content;
    height: max-content;
    font-size: 14px;
    font-weight: bold;
    z-index: 10000000000;

    div {
        cursor: pointer;
        margin: 8px 0;
        padding: 2px 5px;
        background: #fff;
        display: flex;
        align-items: center;
        border: 1px solid #eceaea;
        img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            // margin: 2px 0 0;
        }
    }
}
</style>
